import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
}
export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary'
}) => {
  return <button className={`px-5 py-2.5 rounded-full font-light text-sm transition-all duration-300 ${variant === 'primary' ? 'bg-[#d4af37] text-white hover:bg-[#c9a42f]' : 'bg-[#f7f3ef] text-[#666666] hover:bg-[#ede9e5]'}`} data-id="element-1534">
      {children}
    </button>;
};